import { ReminderType } from "./resourcesTypes"

export const REMINDER_OPTIONS: Record<
    ReminderType,
    {
        showDropdown: boolean
        dropdownOptions?: number[]
        showTextField?: boolean
    }
> = {
    [ReminderType.MEETING_CONFIRMATION]: {
        showDropdown: false,
    },
    [ReminderType.FIRST_REMINDER]: {
        showDropdown: true,
        dropdownOptions: [-24 * 60, -48 * 60],
    },
    [ReminderType.MEETING_START]: {
        showDropdown: true,
        dropdownOptions: Array.from({ length: 56 }, (_, i) => 60 - i),
    },
    [ReminderType.PREPARATION]: {
        showDropdown: true,
        dropdownOptions: [1 * 60, 2 * 60, 4 * 60, 8 * 60, 12 * 60, 24 * 60, 48 * 60],
        showTextField: true,
    },
    [ReminderType.CLEANUP]: {
        showDropdown: true,
        dropdownOptions: [1 * 60, 2 * 60, 4 * 60, 8 * 60, 12 * 60, 24 * 60, 48 * 60],
        showTextField: true,
    },
    [ReminderType.CUSTOM_REMINDER]: {
        showDropdown: true,
        dropdownOptions: [
            5,
            15,
            30,
            60 * 1,
            60 * 2,
            60 * 4,
            60 * 8,
            60 * 12,
            60 * 24,
            60 * 48,
            -5,
            -15,
            -30,
            -60 * 1,
            -60 * 2,
            -60 * 4,
            -60 * 8,
            -60 * 12,
            -60 * 24,
            -60 * 48,
        ],
        showTextField: true,
    },
}
